document.addEventListener('click', function(e) {
    let button = e.target;
    if( button && button.classList.contains("dropdown-toggle") ){
        const menu = button.nextElementSibling;
        menu.classList.toggle("active");
        if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
            button.setAttribute( 'aria-expanded', 'false' );
        } else {
            button.setAttribute( 'aria-expanded', 'true' );
        }
    }
})

let search;
let year;
let type;
let yearSpan = "Publish Dates";
let typeSpan = "Media Types";
let catSpan = "Topics";

// AJAX Handlers
jQuery(function($){

    function filterPostsHandler(event) {
        event.preventDefault();
        var target = $(this);
        newYear = $(this).data('year');
        newType = $(this).data('type');
        newName = $(("span"), target).html();
        var page_num = 1;
        var href = $(this).attr('href');

        if( href != '#') {
            page_num = /[\?&]paged=(\d+)/.test( href ) && RegExp.$1;
        }
        
        var category = $(".category-id").data('id');
        var catSpan = $('.category-id').html();

        // set new values
        if( $(this).hasClass('dropdown-type') ) {
            type = newType;
            typeSpan = newName;
        }
        if( $(this).hasClass('dropdown-year') ) {
            year = newYear;
            yearSpan = newName;
        }  

        // check for search
        if( $(".search-field_resources").val() ) {
            search = $(".search-field_resources").val();
        }
        
        $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_resources',
            type: type,
            category: category,
            year: year,
            search: search,
            paged: page_num || 1
        },
        success: function(res) {
            $('.resources-posts').html(res);

            $('.typefilter-label').html(typeSpan);
            $('.yearfilter-label').html(yearSpan);
            $('.categoryfilter-label').html(catSpan);

            if( $(document.body).hasClass('blog') ) {
                $('#category-all').addClass('active');
            }

            var currentType = $('.dropdown-item[data-type=' + type + ']');
            currentType.addClass("active");

            var currentYear = $('.dropdown-item[data-year=' + year + ']');
            currentYear.addClass("active");

            var currentCat = $('.category-link[data-cat=' + category + ']');
            currentCat.addClass("active");

            // scroll to top on paged
            if(page_num > 1) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#resources-content").offset().top
                }, 1000);
            }
        }
        })
    }

    $(document).on('click', '.dropdown-trigger', filterPostsHandler);
    $(document).on( 'click', '.nav-links-filter a', filterPostsHandler);
});
